import { render, staticRenderFns } from "./newsdetails.vue?vue&type=template&id=912fc1b0&scoped=true"
import script from "./newsdetails.vue?vue&type=script&lang=js"
export * from "./newsdetails.vue?vue&type=script&lang=js"
import style0 from "./newsdetails.vue?vue&type=style&index=0&id=912fc1b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912fc1b0",
  null
  
)

export default component.exports